import React, { useState, useEffect } from "react";
import BaseLayout from "./BaseLayout";
import "../App.css";
import { API_BASE } from "../api";

//component for notify of email
/*function Toast({ message, onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="toast">
      {message}
    </div>
  );
}*/

function FAQ({ faqs }) {
  const [activeId, setActiveId] = useState(null);

  const toggle = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  return (
    <div className="faq-section">
      {faqs.map(faq => (
        <div key={faq.id} className="faq-item">
          <button className="faq-question" onClick={() => toggle(faq.id)}>
            {faq.question}
          </button>
          <div className={`faq-answer ${activeId === faq.id ? 'open' : ''}`}>
            {faq.answer}
          </div>
        </div>
      ))}
    </div>
  );
}

const SupportPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitStatus, setSubmitStatus] = useState(null); // null | 'success' | 'error'
  const faqs = [
    { id: 1, question: "How do I reset my password?", answer: "Go to your settings page and click on 'Reset Password.'" },
    { id: 2, question: "How is leaderboard rank determined?", answer: "Leaderboard rank is determined by a combination of total games and winning percentage. Even a perfect record will eventually be passed by a user who is more active." },
    { id: 3, question: "How do I contact support?", answer: "You can contact us via the support form on this page or directly email us at FlamePicksHelp@gmail.com." }
  ];

  useEffect(() => {
    document.body.classList.add("support-page-bg");

    return () => {
      document.body.classList.remove("support-page-bg");
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = { email, message };
    if(data.email === '' || data.message === '') {
      setSubmitStatus('error-empty');
      return;
    }

    const response = await fetch(`${API_BASE}/mail/send-email`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (response.ok) {
        await response.json();
        setSubmitStatus('success');
        setEmail('');
        setMessage('');
    } else {
        const errorData = await response.json();
        console.error('Failed to send email:', errorData);
        setSubmitStatus('error');
    }
  };

  return (
    <BaseLayout>
      <div className="support-container">
        <h1 className="support-header">Support</h1>
        <div className="support-content">
          <div className="support-column">
            <form className="contact-form" onSubmit={handleSubmit}>
              <input 
                type="email" 
                className="form-input input-default-font" 
                placeholder="Your email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
              />
              <textarea 
                className="form-textarea input-default-font" 
                placeholder="Your message" 
                value={message} 
                onChange={(e) => setMessage(e.target.value)} 
              ></textarea>
              {submitStatus === 'success' && (
                <p style={{ color: 'green', fontWeight: 'bold', fontSize: '0.95rem', margin: '4px 0' }}>Email sent successfully!</p>
              )}
              {submitStatus === 'error' && (
                <p style={{ color: 'red', fontWeight: 'bold', fontSize: '0.95rem', margin: '4px 0' }}>Failed to send email. Please try again later.</p>
              )}
              {submitStatus === 'error-empty' && (
                <p style={{ color: 'red', fontWeight: 'bold', fontSize: '0.95rem', margin: '4px 0' }}>Please fill out both fields.</p>
              )}
              <button type="submit" className="submit-button">Submit</button>
            </form>
          </div>
          <div className="support-column">
            <FAQ faqs={faqs} />
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default SupportPage;
